// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"TextBlock_noScrolling__cvM6_","reset":"TextBlock_reset___7UtM"};